module.exports = __webpack_public_path__ + "static/media/icon-dev-ic-update.91c9e93d.svg";